module.exports = __webpack_public_path__ + "static/media/blob.cc08a72a.svg";